import PropTypes from 'prop-types';

const ViewReport = ({
  jobId,
  onClick,
}) => (
  <button
    type="button"
    className="inline-flex items-center font-medium text-nowrap text-primary-300 cursor-pointer focus:outline-none"
    onClick={() => onClick(jobId)}
  >
    View Report
  </button>
);

ViewReport.propTypes = {
  jobId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ViewReport;
